import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SampleService } from '../../../core/http/sample.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/core/http/settings.service';
import { AuthServiceService } from 'src/app/core/http/auth-service.service';
import { BillingService } from 'src/app/core/http/billing.service';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-refund-receipt-modal',
  templateUrl: './refund-receipt-modal.component.html',
  styleUrls: ['./refund-receipt-modal.component.scss'],
})
export class RefundReceiptModalComponent implements OnInit {
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any = [];
  templates: any = [];
  receipt;
  payment: any = [];
  recLoad: boolean = false;
  tempLoad: boolean = false;
  reLoad: boolean = false;
  encounters: any = [];
  detail;
  detail2;
  detail3;
  name: string = localStorage.getItem('username');
  appversion: any = JSON.parse(localStorage.getItem('appversion'));
  ref: any;

  startdate = localStorage.getItem('startdate');
  enddate = localStorage.getItem('enddate');
  sd;
  ed;
  is_verified = -1;
  dept_code = 0;
  sub_dept_code = 0;
  investigation = '';
  nameSearch = '';
  gender = '';
  phone = '';
  is_finalized = -1;
  is_acknowledged = -1;
  is_collected = -1;
  depts: any = [];
  subDepts: any = [];
  investigatonList: any = [];

  Template_Text = '';

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });

  @Input() info;

  constructor(
    public router: Router,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    // console.log(this.data);
    console.log(this.data, 'dataooooooooooooooo');
    this.getDetail(this.data.bill_Id);
  }

  getResult() {
    this.sample.getResults(this.startdate, this.enddate).subscribe(
      (resSuccess:any) => {
        this.data = resSuccess.data;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
  }

  getReceipt(receipt_no) {
    this.recLoad = true;
    this.sample.printReciept(receipt_no).subscribe(
      (resSuccess) => {
        this.recLoad = false;
        this.receipt = resSuccess;
        console.log(this.receipt);
      },
      (resErr) => {
        this.Errors = resErr;
        this.recLoad = false;
      }
    );
  }

  cachebillInfo(details, patientInfo) {
    this.auth.currentBillItem(details);
    this.auth.currentPatient(patientInfo);
    // console.log(details, 'firssttttttttttttt');
  }

  getTemplate(result_id) {
    this.sample.getPrintResult(result_id).subscribe(
      (resSuccess) => {
        this.tempLoad = false;
        this.templates = resSuccess;
        this.Template_Text = this.templates.data.test_body;
        // console.log(resSuccess)
      },
      (resErr) => {
        this.tempLoad = false;
        this.Errors = resErr;
      }
    );
  }

  back() {
    this.modal.closeModal();
    location.reload();
  }
  setReceipt() {
    this.mode = 'rec';
  }
  done() {
    this.mode = 'form';
    this.stateForm.patchValue({
      formatstr: this.Template_Text,
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text;
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('Error Please Try Agian');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
    this.sample.postResultFinalize(result_id, is_finalized).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  printResult(): void {
    let printContents, popupWin;
    printContents = document.getElementById('receipt').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #receipt {
            width: 500px;
            margin-left: 100px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
    location.reload();
  }

  async getDetail(Bill_ID) {
    // console.log(this.detail, 'Detaillllllllllllllll');
    this.reLoad = true;
    console.log(Bill_ID);

    try {
      const billDetail = await this.bill.getBillDetail(Bill_ID).toPromise();
      this.reLoad = false;
      this.detail = billDetail;
      console.log(this.detail);
      console.log(billDetail.registration_no);
      const patientInfo = await this.bill
        .getPatients(billDetail.registration_no)
        .toPromise();
      console.log(patientInfo);
      this.cachebillInfo(billDetail, patientInfo);
      this.detail2 = patientInfo[0]?.date_of_birth;
      this.detail3 = this.detail2.slice(0, 10);

      const refDrResponse = await this.bill
        .getRefDrByCode(patientInfo[0].ref_doct_code)
        .toPromise();
      console.log(refDrResponse);
      this.ref = refDrResponse[0];
      console.log('Detail after getDetail:', this.detail); // Debugging statement
    } catch (error) {
      this.Errors = error;
      console.log(error);
      this.reLoad = false;
    }
  }
}
